import React from 'react';
import { InputAdornment, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-premium";
import {
  byzSearchInputSx,
  BYZ_SEARCH_ICON_COLOR,
  BYZ_SEARCH_ICON_SIZE,
} from "src/components/core-components/mui/inputs/byzSearchInputStyles";

interface ByzDataGridToolbarProps {
  searchPlaceholder?: string;
  color?: string;
  containerSx?: any;
  toolbarSx?: any;
  searchInputSx?: any;
  /** Mavi underline stilini kullan (ByzSearchInput ile aynı tasarım) */
  searchIconColor?: string;
}

const ByzDataGridToolbar: React.FC<ByzDataGridToolbarProps> = ({
  searchPlaceholder = "Ara",
  color = "#00B8D9",
  containerSx = {},
  toolbarSx = {},
  searchInputSx = {},
  searchIconColor,
}) => {
  const useUnderlineStyle = !!searchIconColor;
  const iconColor = searchIconColor ?? BYZ_SEARCH_ICON_COLOR;

  const searchInputProps = useUnderlineStyle
    ? {
      startAdornment: (
        <InputAdornment position="start" sx={{ marginLeft: 0, paddingLeft: 0 }}>
          <SearchIcon sx={{ color: iconColor, fontSize: BYZ_SEARCH_ICON_SIZE }} />
        </InputAdornment>
      ),
    }
    : undefined;

  const finalSearchInputSx = useUnderlineStyle
    ? { ...byzSearchInputSx, ...searchInputSx }
    : searchInputSx;

  return (
    <GridToolbarContainer sx={{ color, ...containerSx } as any}>
      <GridToolbarColumnsButton
        slotProps={{
          button: {
            startIcon: (
              <Box
                component="img"
                src="/assets/icons/grid/ViewColumnFilled.svg"
                sx={{ width: 16, height: 18 }}
                alt=""
              />
            ),
          },
        }}
      />
      <GridToolbarFilterButton
        slotProps={{
          button: {
            startIcon: (
              <Box
                component="img"
                src="/assets/icons/grid/FilterListFilled.svg"
                sx={{ width: 16, height: 18 }}
                alt=""
              />
            ),
          },
        }}
      />
      <GridToolbarDensitySelector
        slotProps={{
          button: {
            startIcon: (
              <Box
                component="img"
                src="/assets/icons/grid/TableRowsFilled.svg"
                sx={{ width: 16, height: 18 }}
                alt=""
              />
            ),
          },
        }}
      />
      <GridToolbarExport
        slotProps={{
          button: {
            startIcon: (
              <Box
                component="img"
                src="/assets/icons/grid/SaveAltFilled.svg"
                sx={{ width: 16, height: 18 }}
                alt=""
              />
            ),
          },
        }}
      />
      <GridToolbarQuickFilter
        placeholder={searchPlaceholder}
        sx={{ ml: "auto", ...finalSearchInputSx }}
        InputProps={searchInputProps}
      />
    </GridToolbarContainer>
  );
};

export default ByzDataGridToolbar;
